<div class="irembogov-configuration-form-builder officer-form mt-5 w-100">
  <div class="w-100">
    <div #errorMessageElement class="px-5">
      <irembogov-irembo-section-message
        *ngIf="showConfigFormErrorMessage"
        [type]="formAlertContent.type"
        [title]="formAlertContent.title"
        [message]="formAlertContent.message"
        [extraMessage]="formAlertContent.extraMessage"
        [extraMessageAsHtml]="true">
      </irembogov-irembo-section-message>
    </div>
  </div>

  <div class="w-100">
    <div class="bg-white rounded-1 p-3 col-12" *ngIf="formExistsForm">
      <form [formGroup]="formExistsForm" class="row mb-3">
        <h5 class="mb-4 font-weight-bold border-bottom-secondary">
          Does the service have an officer form?
        </h5>
        <div class="form-group row">
          <div class="col-xl-3 col-lg-3 col-md-2 col-sm-2 col-xs-3">
            <div
              class="card mb-2"
              [ngClass]="
                formExistsForm.controls['formExists'].value === 'YES'
                  ? 'card-selected'
                  : ''
              ">
              <div
                class="card-body"
                role="button"
                (click)="onFormExistenceChange('YES')">
                <input
                  name="formExists"
                  [id]="'YES'"
                  [value]="'YES'"
                  formControlName="formExists"
                  class="form-check-input"
                  type="radio" />
                <label [for]="'Yes'" style="padding-left: 12px"> Yes </label>
              </div>
            </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-2 col-sm-2 col-xs-3">
            <div
              class="card mb-2"
              [ngClass]="
                formExistsForm.controls['formExists'].value === 'NO'
                  ? 'card-selected'
                  : ''
              ">
              <div
                class="card-body"
                role="button"
                (click)="onFormExistenceChange('NO')">
                <input
                  name="formExists"
                  [id]="'NO'"
                  [value]="'NO'"
                  formControlName="formExists"
                  class="form-check-input"
                  type="radio" />
                <label [for]="'NO'" style="padding-left: 12px"> No </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div
    class="w-100 d-flex p-3"
    *ngIf="formExistsForm.get('formExists')?.value === 'YES'">
    <div class="flex-grow-1 me-3 preview-section-wrapper">
      <div class="preview-section">
        <div class="bg-white rounded-1 p-3 mb-3">
          <h6 class="mb-3">Officer form workflow transition</h6>
          <div
            class="officer-form-info-banner mb-3"
            role="alert"
            aria-live="polite">
            <i class="fas fa-info-circle me-2" aria-hidden="true"></i>
            <span>
              Only states with an <strong>APPROVE_WITH_FORM</strong> event can
              be configured here.
            </span>
          </div>
          <form
            [formGroup]="transitionForm"
            class="row g-2 align-items-end mb-3">
            <div class="col-lg-4 col-md-5">
              <label class="form-label small mb-1">Start state</label>
              <select class="form-select" formControlName="startState">
                <option value="" disabled>Select start state</option>
                <option
                  *ngFor="let state of availableStartStates"
                  [ngValue]="state">
                  {{ state }}
                </option>
              </select>
              <div class="small text-muted" *ngIf="workflowDropdownsLoading">
                Loading workflow…
              </div>
            </div>
            <div class="col-lg-3 col-md-4">
              <label class="form-label small mb-1">Event</label>
              <select class="form-select" formControlName="event">
                <option value="" disabled>Select event</option>
                <option *ngFor="let ev of availableEvents" [ngValue]="ev">
                  {{ ev }}
                </option>
              </select>
            </div>
            <div class="col-lg-3 col-md-3">
              <button
                type="button"
                class="btn btn-outline-primary mt-3"
                [disabled]="transitionForm.invalid"
                (click)="onAddTransitionFromForm()">
                + Add transition
              </button>
            </div>
          </form>

          <div
            *ngIf="transitionKeys.length === 0"
            class="small text-muted mt-2">
            Add a start state and event to create the first officer form
            section. Once created, use the builder on the right to design the
            officer form.
          </div>

          <!-- List of forms (one card per transition), driven by JSON keys -->
          <div class="mt-3" *ngIf="transitionKeys.length > 0">
            <div class="small mb-2 text-muted">Transitions</div>
            <div
              *ngFor="let key of transitionKeys"
              class="irembogov-formly-field-group card mb-3">
              <div
                class="card-header bg-transparent border-bottom h6 my-2 d-flex align-items-center justify-content-between"
                role="button"
                (click)="onTransitionKeyChange(key)">
                <div class="d-flex align-items-center">
                  <i class="fa-solid fa-rectangle-list me-1 text-primary"></i>
                  <span class="text-truncate">{{ key }}</span>
                </div>
                <button
                  *ngIf="key === selectedTransitionKey"
                  type="button"
                  class="btn btn-link text-danger p-1 border-0"
                  title="Delete transition"
                  aria-label="Delete transition"
                  (click)="
                    onDeleteSelectedTransition(); $event.stopPropagation()
                  ">
                  <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
                </button>
              </div>
              <div
                class="card-body border-0 pt-0"
                *ngIf="key === selectedTransitionKey">
                <div class="preview-box">
                  <div
                    class="preview-box-invalid"
                    *ngIf="this.jsonEditorValidationErrors.length > 0">
                    Invalid Json Object in Code Editor
                  </div>
                  <div class="preview-box-view">
                    <irembogov-preview-service-change-request-json-formdata-widget
                      [showHiddenAndHideFieldControls]="true">
                    </irembogov-preview-service-change-request-json-formdata-widget>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="justify-self w-40 side-pane-wrapper">
      <div class="side-pane">
        <irembogov-service-change-request-feedback-handler-widget
          *ngIf="changeRequest || template"
          (selectOptionChanged)="onTabSelectChanged($event)"
          [changeRequestId]="changeRequest?.id || template?.id || ''"
          [serviceChangeRequestSection]="
            EServiceChangeRequestSection.OFFICER_FORM
          "
          [selectedOption]="selectedToggleHeader">
          <div wizard>
            <irembogov-form-field-configurator></irembogov-form-field-configurator>
          </div>
          <div codeEditor>
            <div class="code-editor-section">
              <div class="mb-3">
                <div class="form-group">
                  <div class="input-group mb-3">
                    <json-editor
                      [options]="editorOptions"
                      id="jsonFormData"
                      class="form-control p-0 json-form-data-field"
                      (change)="onCodeEditorChanged()"
                      inputMode="code"
                      [data]="
                        jsonEditorFormData
                          ? jsonEditorFormData
                          : DefaultEmptyFormData
                      "
                      #jsonFormData>
                    </json-editor>
                  </div>
                  <div
                    class="form-error w-100 small text-danger"
                    *ngIf="jsonEditorValidationErrors.length > 0">
                    JSON input is invalid
                    <ol>
                      <li
                        class="w-100 small"
                        *ngFor="
                          let error of jsonEditorValidationErrors;
                          let index = index
                        ">
                        <em class="text-muted"> Line {{ error['line'] }} </em>
                        <br />
                        <small [innerHTML]="error['message']"></small>
                      </li>
                    </ol>
                  </div>
                  <div
                    class="form-error w-100 small text-danger"
                    *ngIf="jsonEditorFormData.length === 0">
                    Please enter a JSON Form entry
                  </div>
                </div>
              </div>
            </div>
          </div>
        </irembogov-service-change-request-feedback-handler-widget>

        <div class="px-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="small text-muted" *ngIf="autoSaveInProgress">
              <div
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                style="width: 0.8rem; height: 0.8rem"></div>
              <span>Autosaving...</span>
            </div>
            <div
              class="small text-muted"
              *ngIf="lastAutoSaved && !autoSaveInProgress">
              <span>Last saved: {{ lastAutoSaved | date : 'medium' }}</span>
            </div>
            <div class="text-end">
              <button
                (click)="onThirdPartyFormSubmit()"
                class="btn btn-primary mt-1 px-5"
                type="button"
                [disabled]="
                  isLoading ||
                  jsonEditorValidationErrors.length > 0 ||
                  formExistsForm.invalid
                ">
                <div
                  *ngIf="isLoading"
                  class="spinner-border spinner-border-sm mr-2"
                  role="status"></div>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="w-100 d-flex p-3"
    *ngIf="formExistsForm.get('formExists')?.value === 'NO'">
    <div class="ms-auto text-end w-100">
      <button
        (click)="onThirdPartyFormSubmit()"
        class="btn btn-primary mt-1 px-5"
        type="button"
        [disabled]="isLoading || formExistsForm.invalid">
        <div
          *ngIf="isLoading"
          class="spinner-border spinner-border-sm mr-2"
          role="status"></div>
        Continue
      </button>
    </div>
  </div>
</div>
